export default __webpack_public_path__ + "static/media/slide 2-02.22f89de4.jpg";